export function endereco (obj, string = "logradouro, nº numero, bairro, cidade - uf, cep") {
  let newEndereco = obj

  if (obj && obj.length) {
    let { endereco } = obj[0]
    newEndereco = endereco
  }

  Object.keys(newEndereco).map(key => {
    try {
      if (newEndereco[key]) {
        string = string.replace(`${key}`, newEndereco[key])
      } else {
        if (key == 'complemento') return
        string = string.replace(`${key}`, `[ ${key.toUpperCase()} Não informado ]`)
      }
    } catch (e) {
      console.log(e)
      console.log(key, newEndereco[key])
    }
  })
  return string
};
